interface Params {
  text?: string;
  year?: string;
  programName?: string;
  donationTotalDisplay?: string;
  programNameAlt?: string;
  sponsorName?: string;
  reportTense?: string;
  serviceGoal?: string;
  q4Answer?: string;
  primaryBeneficiary?: string;
  q3answerIndicatorDetails?: string;
  q4answerIndicatorDetails?: string;
  q5answerIndicatorDetails?: string;
  serviceExample?: string;
  socialImpactIndicator?: string;
  reportStartDate?: string;
  reportEndDate?: string;
}

export const replaceQuestionText = ({
  text = '',
  programName = 'your program',
  donationTotalDisplay = '',
  programNameAlt = '',
  sponsorName = '',
  reportTense = '',
  serviceGoal = '',
  q4Answer = '',
  primaryBeneficiary = '',
  q3answerIndicatorDetails = '',
  q4answerIndicatorDetails = '',
  q5answerIndicatorDetails = '',
  serviceExample = '',
  socialImpactIndicator = '',
  reportStartDate = '',
  reportEndDate = '',
  year = '',
}: Params): string => {
  return text
    .replace(/<Program Name>/g, programName)
    .replace(/<Report_year>/g, year)
    .replace(/<Donation_total>/g, donationTotalDisplay)
    .replace(/<Program_name>/g, programName || programNameAlt)
    .replace(/<Sponsor_name>/g, sponsorName)
    .replace(/<Report_tense>/g, reportTense)
    .replace(/<Service_goal>/g, serviceGoal)
    .replace(/<Q4_answer>/g, q4Answer)
    .replace(/<Primary_beneficiary>/g, primaryBeneficiary)
    .replace(/<Q3_answer_indicator_details>/g, q3answerIndicatorDetails)
    .replace(/<Q4_answer_indicator_details>/g, q4answerIndicatorDetails)
    .replace(/<Q5_answer_indicator_details>/g, q5answerIndicatorDetails)
    .replace(/<Service_example>/g, serviceExample)
    .replace(/<Social_impact_indicator>/g, socialImpactIndicator)
    .replace(/<Report_start_date>/g, reportStartDate)
    .replace(/<Report_end_date>/g, reportEndDate)
    .replace(
      /<Primary_beneficiary_or_Intermediary>/g,
      primaryBeneficiary || 'your primary beneficiary',
    );
};
